import React from 'react';
import { Link } from 'react-router-dom';
import { NEW_URL } from '../../../../constants/applicationConstants';
import swal from 'sweetalert';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Import your images
import mywork from "../../../../assets/images/mywork.svg";
import manageexpert from "../../../../assets/images/manageexpert.svg";
import myworkspace from "../../../../assets/images/myworkspace.svg";
import myblog from "../../../../assets/images/myblog.svg";
import myaccount from "../../../../assets/images/myaccount.svg";
import manageinstitute from "../../../../assets/images/manageinstitute.svg";
import assignquestions from "../../../../assets/images/assignquestions.svg";
import manageunverifieduser from "../../../../assets/images/manageunverifieduser.svg";
import manageoffer from "../../../../assets/images/manageoffer.svg";
import manageproduct from "../../../../assets/images/manageproduct.svg";
import logoutIcon from "../../../../assets/images/logout.svg";
import moudleData from "./sidebar.json";

const SideBarsJsx = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { response, transformedData } = props;
  const moduleNames = [...new Set(transformedData?.map(module => module.moduleName))];

  moduleNames.push("Workspace");

  // Icon Mapping
  const iconMap = {
    mywork: mywork,
    manageexpert: manageexpert,
    myworkspace: myworkspace,
    myblog: myblog,
    myaccount: myaccount,
    manageinstitute: manageinstitute,
    assignquestions: assignquestions,
    manageunverifieduser: manageunverifieduser,
    manageoffer: manageoffer,
    manageproduct: manageproduct,
  };

  const logout = () => {
    swal({
      title: "Are you sure you want to Logout ?",
      icon: "warning",
      buttons: [
        'Continue',
        'Logout'
      ],
      dangerMode: true,
    }).then(function (isConfirm) {
      if (isConfirm) {
        localStorage.clear();
        history.push("/");
        window.location.reload();
      }
    });
  };

  const sidebarItems = moudleData;

  // Render logic for modules and accordion sections in one place
  const renderSidebarItem = (item) => {
    if (item.type === "module") {
      if (moduleNames?.includes(item.name)) {
        return (
          <li className={`${window.location.href?.includes(item.link) ? 'active' : ""}`} key={item.name}>
            <Link to={item.link}>
              <img src={iconMap[item.icon]} alt={item.name} />
              {item.label}
            </Link>
          </li>
        );
      }
    } else if (item.type === "accordion") {
      if (moduleNames?.includes(item.key)) {
        return (
          <div className="accordion" id="accordionSidebar" key={item.toggle}>
            <div className="accordion-item">
              <h2 className="accordion-header" id={`heading-${item.toggle}`}>
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${item.toggle}`} aria-expanded="false" aria-controls={`collapse-${item.toggle}`}>
                  {item.name}
                </button>
              </h2>
              <div id={`collapse-${item.toggle}`} className="accordion-collapse collapse" aria-labelledby={`heading-${item.toggle}`} data-bs-parent="#accordionSidebar">
                <div className="accordion-body">
                  {item.modules.map((module, idx) => (
                    <li toggle={idx} className={`${window.location.href?.includes(module.link) ? 'active' : ""}`}>
                      <Link to={module.link}>
                        <img src={iconMap[module.icon]} alt={module.name} />
                        {module.label}
                      </Link>
                    </li>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      }
    }
    return null;
  };

  return (
    <div className="dashboardleftpanel martop40">
      <div className="userdetails">
        <div className="dashboardlogo">
          <img src={`${NEW_URL}/${response?.imageUrl}`} alt={'icon'} />
        </div>
        <div className="responsename">
          {response?.name}<br></br> {t("COMMON.VIEWPROFILE")}
        </div>
      </div>

      <div className="dashboardlink martop40">
        <ul>
          {sidebarItems.map(item => renderSidebarItem(item))}

          <li onClick={logout}><button  ><img src={logoutIcon} alt={'icon'} />Logout</button></li>
        </ul>
      </div>
    </div>
  );
};

export default SideBarsJsx;
